
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class ChromaPointerController {
    constructor($log, $scope, $rootScope, $element, $interval) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$element = $element;
        this.$interval = $interval;

        this.pointerImg = require('_images/chroma-pointer/pointer.png')

        this.cursor = {
            "top": "0px",
            "left": "0px"
        }

        this.cloned = undefined;

        this.disabled = true;
        this.visible = false;

        this.containerEl = $('.stage-container');

        // Watchers
        $rootScope.$on('chroma-pointer:enable',  () => this.disabled = false);
        $rootScope.$on('chroma-pointer:disable', () => this.disabled = true);
        $rootScope.$on('chroma-pointer:hide',    () => this.visible = false);
        $rootScope.$on('chroma-pointer:show',    () => this.visible = true);
        $rootScope.$on('chroma-pointer:trigger:moviment', this.cursorMoviment.bind(this));
        
        $rootScope.$on('ANGULAR_DRAG_START', this.onDragStart.bind(this));

        $scope.$watch('$ctrl.visible', (newValue, oldValue) => {
            if(!newValue){                
                this.disabled = true;

                if (oldValue) this.disabledMoveCapture();
            } else{
                if (!oldValue) this.enabledMoveCapture();
            }
        });

        $scope.$watch('$ctrl.disabled', newValue => {
            if(!newValue){
                this.containerEl.addClass('hide-cursor');
            } else{
                this.containerEl.removeClass('hide-cursor');
            }
        });
    }

    $onInit(){
        this.enabledMoveCapture();
        this.visible = true;
        this.disabled = false;
    }

    enabledMoveCapture(){
        document.querySelector('.stage-container').addEventListener('mousemove', this.cursorMoviment.bind(this));
        document.querySelector('.stage-container').addEventListener("dragover", this.cursorMoviment.bind(this));            
    }
    
    disabledMoveCapture(){
        document.querySelector('.stage-container').removeEventListener('mousemove', this.cursorMoviment.bind(this));
        document.querySelector('.stage-container').removeEventListener('dragover', this.cursorMoviment.bind(this));            
    }

    cursorMoviment($event, data){
        // Check if cursor event trigger from angular or native
        let event = data ? data : $event;


        let hasPuzzlePartImgClass = $(event.target).hasClass('puzzle-part-img');
        let hasPuzzlePartClass = $(event.target).hasClass('puzzle-part');
        
        if (!hasPuzzlePartImgClass || hasPuzzlePartClass) event.preventDefault();
        
        if(this.disabled) return;
        
        window.requestAnimationFrame(() =>{
            let { pageX, pageY } = event;
            
            let top = ( pageY - this.containerEl.offset().top ) - 16;
            let left = (pageX - this.containerEl.offset().left ) - 16;

            top = top < 0 ? Math.abs(top) : top
            left = left < 0 ? Math.abs(left) : left;
    
            this.cursor["top"] =  `${top}px`;
            this.cursor["left"] = `${left}px`;

            this.$scope.$apply()        
        });
    }

    onDragStart(event, data){
        // this.$log.log(event, data);
        let crt = data.target.cloneNode(true);
        crt.style.display = "none";
        document.body.appendChild(crt);
        this.$log.log(crt);
        data.dataTransfer.setDragImage(crt, 0, 0);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/chroma-pointer/chroma-pointer.controller.js